<template>
        <v-card>
            <v-card-text>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate
                        color="primary">
                    </v-progress-circular>
                </div>
                <v-simple-table
                    dense
                    v-else>
                    <tbody>
                        <tr>
                            <th>رقم اللوحة</th>
                            <td>{{truck.plate_number}}</td>
                        </tr>
                        <tr>
                            <th>نوع الالية</th>
                            <td>{{truck.truck_type}}</td>
                        </tr>
                        <tr>
                            <th>ماركة الالية</th>
                            <td>{{truck.truck_brand}}</td>
                        </tr>
                        <tr>
                            <th>سنة الصنع</th>
                            <td>{{truck.year_make}}</td>
                        </tr>

                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: "DriverDisplayMenu",
    props: {
        truckId: Number
    },
    data() {
        return {
            loading: {
                data: true
            }
        }
    },
    computed: {
        ...mapState("truck", ["truck"])
    },
    methods: {
        ...mapActions("truck", ["fetchTruck"])
    },
    async created() {
        await this.fetchTruck(this.truckId);
        this.loading.data = false;
    }
}
</script>